import { NonIdealState } from "@blueprintjs/core";
import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { ClubApi, ClubGridDto } from "../../../api";
import { ViewButton } from "../../../components";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { DrupalDataTable } from "../../common";
import { DrupalFieldSet } from "../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../EDrupalRoutes";

export interface IDrupalClubListProps {
  breedId: number;
}

export const DrupalClubList: React.FunctionComponent<IDrupalClubListProps> = ({ breedId }) => {
  const api = useApiService(ClubApi);
  const { t } = useTl();
  const history = useHistory();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: false,
    enableFilter: false,
  });
  const { totalCount } = tableState;
  const searchFunction = React.useCallback(() => {
    if (breedId) {
      return api.searchByBreed(breedId);
    }
  }, [api, breedId]);

  const { search, loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });
  const redirect = React.useCallback(
    (clubId: number) => {
      history.push(`${EDrupalRoutes.club}/${clubId}`);
    },
    [history]
  );

  React.useEffect(() => {
    search();
  }, [breedId, search]);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        fieldName: "_action",
        header: () => "",
        alignment: "center",
        render: (row: ClubGridDto) => <ViewButton onClick={() => redirect(row.clubId)} secured={false} />,
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        computed: true,
        disableSorting: true,
      },
      {
        header: () => t(ETLCodes.Email),
        fieldName: "globalEmail",
        computed: true,
        disableSorting: true,
      },
      {
        header: () => t(ETLCodes.PhoneNumber),
        fieldName: "phoneNumber",
        computed: true,
        disableSorting: true,
      },
      {
        header: () => t(ETLCodes.Website),
        fieldName: "websiteAddress",
        computed: true,
        disableSorting: true,
        render: (row: ClubGridDto) => (
          <a target="_blank" rel="noopener noreferrer" href={row.websiteAddress}>
            {row.websiteAddress}
          </a>
        ),
      },
    ],
    [redirect, t]
  );

  return (
    <DrupalFieldSet title={`${t(ETLCodes.Clubs)} (${totalCount})`}>
      {breedId ? (
        <DrupalDataTable tableState={tableState} loading={loading} columns={columns} />
      ) : (
        <NonIdealState icon="series-search" title={t(ETLCodes.PLeaseSelectBreed)} />
      )}
    </DrupalFieldSet>
  );
};
